import { styled } from '@mui/material';

const StyledSeparator = styled('div')({
  height: '1px',
  margin: '8px 0',
  background: 'var(--color-general-grey-400)',
  opacity: '0.3',
});

export const Separator = () => {
  return <StyledSeparator />;
};
